var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.lgAndUp),expression:"$vuetify.breakpoint.lgAndUp"}],attrs:{"cols":"12","lg":"3"}},[_c('TheSideNavigation')],1),_c('v-col',{attrs:{"cols":"12","lg":"9"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }